export default {
	title: 'Portfolio',
	description: 'Tutti i miei progetti Gerositus',
	actions: {
		back_to_this: 'Torna al portfolio'
	},
	search_projects: 'Cerca progetti',
	cta: {
		welcome: 'Benvenuto e grazie per aver effettuato l’accesso a Gerositus Strategy Suite!',
		subscribe: 'Abbonati ora',
		create_permission: 'per poter creare nuovi progetti.'
	},
	tabs: {
		risks: {
			title: 'Parametri di rischi e opportunità'
		}
	}
};
